import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import type { OutlookCloudPolicyData } from '../store/schema/OutlookCloudPoliciesSchema';
import type { OutlookCloudPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';
import getStore from '../store/store';
import { settingIdToFeature } from '../utils/featureSettingIds';
import isGlobalSettingsMailbox from 'owa-account-source-list-store/lib/utils/isGlobalSettingsMailbox';
import { getAccountScopeUserSettings } from 'owa-session-store';

const PRIME_BOOT_OCPS_SETTING_ID = 'OutlookCloudPolicies';

export function getPolicyDataBySettingId(
    mailboxInfo: MailboxInfo,
    settingId: OutlookCloudPolicySettingId
): OutlookCloudPolicyData | undefined {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const feature = settingIdToFeature[settingId];
    const storePolicyData = getStore().get(accountKey)?.policies[feature]?.[settingId];

    // If the policy data is not found in the store and the mailbox is the global settings mailbox, attempt to retrieve it from the prime boot settings.
    // This is a fallback mechanism to ensure that we can still retrieve OCPS policies for the global settings mailbox even if they haven't been fetched and stored in the local store yet.
    // We will only have the mission critical OCPS policies available in the prime boot settings, so this is not always guaranteed to return a value,
    // but it provides an additional opportunity to retrieve important policies for the global settings mailbox.
    if (!storePolicyData && isGlobalSettingsMailbox(mailboxInfo)) {
        const primeSettingsItems = getAccountScopeUserSettings(mailboxInfo)?.PrimeSettings?.Items;
        const ocpsPrimeSetting = primeSettingsItems?.find(
            (item: any) => item?.Id === PRIME_BOOT_OCPS_SETTING_ID
        );
        if (ocpsPrimeSetting) {
            const bootPolicies: Array<OutlookCloudPolicyData> | undefined =
                ocpsPrimeSetting.Value?.policies;
            const bootPolicyItem = bootPolicies?.find(p => p.settingId === settingId);
            return bootPolicyItem;
        }
    }

    return storePolicyData;
}
